/**
 * Helpers to derive an SLA pill from a Ticket + (optional) Contract.
 *
 * Internal/BAU contracts have no countdown — `null` is returned and
 * the row should reserve the same horizontal space (a fixed-width
 * placeholder) to keep alignment.
 */

import {
  computeSolutionSnapshot,
  type SlaSnapshot,
  type SlaContract,
  type Contract,
  type Ticket,
} from '@beacon/core';

export function slaSnapshotFor(
  ticket: Ticket,
  contract: Contract | undefined,
  now: Date
): SlaSnapshot | null {
  if (!contract || contract.type !== 'sla') return null;
  return computeSolutionSnapshot(ticket, contract as SlaContract, now);
}
